import React from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";

import {
    isMobile,
    parseWithPitchNotation,
    getSolfaName,
    localizeAbc,
    lengthenSolfa,
    i18nSolfa,
} from "../../../../../../../common/parameters";

import { IUser, PitchNotation } from "../../../../../../store/user/models";
import { IStateTree } from "../../../../../../store/interfaces";

import {
    StyledWhiteButtonWrapper,
    StyledWhiteButton,
} from "../styles";
import BlackButton from "../BlackButton";
import { getPitch } from "../utils";
import { formatABC, ABC } from "./utils";
import { IProps } from "./interfaces";

const WhiteButton = ({
    withBlack,
    left,
    right,
    index,
    click,
    min,
    max,
    octave,
    isLow,
    notes,
    hintNote,
    withSolfa,
    doOctave,
    doPos,
}: IProps) => {
    const { pitchNotation = PitchNotation.Helmholtz, solfaShort = false, solfaKam = false } = useSelector((state: IStateTree) => state.user as IUser);
    const { locale } = useIntl();
    const action = {
        [isMobile ? "onTouchStart" : "onClick"]: (e: TouchEvent | MouseEvent) => click(index, null, true, e),
    };
    let text = " ";
    if (!withSolfa) {
        let abc = formatABC(ABC(locale)[index % 12], octave);
        if (locale === "it" || locale === "es" || locale === "ca") {
            abc = localizeAbc(abc, "it");
        } else if (locale === "el") {
            abc = localizeAbc(abc, "el");
        }
        text = parseWithPitchNotation(abc, pitchNotation);
    } else {
        const pitch = getPitch({ doPos, doOctave, index });
        if (pitch.a === 0) {
            text = lengthenSolfa(i18nSolfa(getSolfaName(pitch, locale), locale, solfaKam), locale, solfaShort);
        }
    }

    return (
        <StyledWhiteButtonWrapper isLow={isLow}>
            <StyledWhiteButton
                className={hintNote && hintNote.includes(index) ? "PulsatePiano" : undefined}
                disabled={index < min || index > max}
                {...action}
                isLow={isLow}
                selected={notes.indexOf(index) !== -1}
            >
                {text}
            </StyledWhiteButton>
            {withBlack && (
                <BlackButton
                    min={min}
                    max={max}
                    left={left}
                    right={right}
                    index={index + 1}
                    click={click}
                    isLow={isLow}
                    notes={notes}
                    hintNote={hintNote}
                    doPos={doPos}
                    doOctave={doOctave}
                    withSolfa={withSolfa}
                />
            )}
        </StyledWhiteButtonWrapper>
    );
};

export default WhiteButton;
